export function isV2StationeryPreviewEnabled(
  globalConfig?: { [key: string]: unknown }
): boolean {
  const value = globalConfig?.use_v2_stationery;
  if (typeof value === "string") {
    const normalized = value.toLowerCase();
    return normalized === "yes" || normalized === "true";
  }
  return value === true;
}
